
import u from "umbrellajs"
import _once from "lodash/once"

import DataRetriever from "app/data_retriever"

/* eslint-disable @stylistic/indent */
enum Enum {
  city_level_landing_page = "City Level Landing Page",

  about_us_page = "About Us Page",

  city_level_residential_neighbourhood_list_page =
    "city_level_residential_neighbourhood_list_page",

  city_level_residential_rental_onboarding_page =  "City Rental Question Page",
  city_level_residential_sale_onboarding_page =    "City Sale Question Page",

  city_level_commercial_rental_onboarding_page =
    "Commercial City Level Rental Onboarding Page",
  city_level_commercial_sale_onboarding_page =
    "Commercial City Level Sale Onboarding Page",

  city_level_residential_for_rent_listing_search_page = "City For Rent Page",
  city_level_residential_for_sale_listing_search_page = "City For Sale Page",

  city_level_commercial_for_rent_listing_search_page =
    "city_level_commercial_for_rent_listing_search_page",
  city_level_commercial_for_sale_listing_search_page =
    "city_level_commercial_for_sale_listing_search_page",


  single_residential_neighbourhood_summary_page =
    "single_residential_neighbourhood_summary_page",

  neighbourhood_level_residential_for_rent_listing_search_page =
    "neighbourhood_level_residential_for_rent_listing_search_page",
  neighbourhood_level_residential_for_sale_listing_search_page =
    "neighbourhood_level_residential_for_sale_listing_search_page",

  neighbourhood_level_residential_transaction_list_page =
    "neighbourhood_level_residential_transaction_list_page",

  neighbourhood_level_expired_residential_for_rent_listing_list_page =
    "neighbourhood_level_expired_residential_for_rent_listing_list_page",
  neighbourhood_level_expired_residential_for_sale_listing_list_page =
    "neighbourhood_level_expired_residential_for_sale_listing_list_page",


  single_residential_building_summary_page =
    "single_residential_building_summary_page",
  building_level_residential_for_rent_listing_search_page =
    "building_level_residential_for_rent_listing_search_page",
  building_level_residential_for_sale_listing_search_page =
    "building_level_residential_for_sale_listing_search_page",
  building_level_residential_transaction_list_page =
    "building_level_residential_transaction_list_page",

  building_level_expired_residential_for_rent_listing_list_page =
    "building_level_expired_residential_for_rent_listing_list_page",
  building_level_expired_residential_for_sale_listing_list_page =
    "building_level_expired_residential_for_sale_listing_list_page",


  city_level_special_categories_landing_page =
    "city_level_special_categories_landing_page",
  city_level_special_categories_for_rent_listing_search_page =
    "city_level_special_categories_for_rent_listing_search_page",
  city_level_special_categories_for_sale_listing_search_page =
    "city_level_special_categories_for_sale_listing_search_page",

  city_level_village_houses_for_rent_listing_search_page =
    "city_level_village_houses_for_rent_listing_search_page",
  city_level_village_houses_for_sale_listing_search_page =
    "city_level_village_houses_for_sale_listing_search_page",


  city_level_home_ownership_scheme_landing_page =
    "city_level_home_ownership_scheme_landing_page",
  neighbourhood_level_home_ownership_scheme_summary_page =
    "neighbourhood_level_home_ownership_scheme_summary_page",
  neighbourhood_level_home_ownership_scheme_for_rent_listing_search_page =
    "neighbourhood_level_home_ownership_scheme_for_rent_listing_search_page",
  neighbourhood_level_home_ownership_scheme_for_sale_listing_search_page =
    "neighbourhood_level_home_ownership_scheme_for_sale_listing_search_page",

  internal_sales_report_listings_page = "Internal Sales Report Listings Page",
  internal_sales_report_listings_summary_page = "Internal Sales Report Listing Summary Page",
  internal_sales_report_listings_record_page = "Internal Sales Report Listings Record Page",
  internal_sales_report_listing_contact_requests_page = "Internal Sales Report Enquiries Page",
  internal_sales_report_neighbourhood_level_email_enquiry_report_page = "Internal Reports Neighbourhood Level Email Enquiry Report page",
  internal_sales_report_serviced_apartment_providers_page = "Internal Sales Report Serviced Apartment Providers Page",
  internal_sales_report_overseas_properties_page = "Internal Sales Report Overseas Properties Page",
  internal_sales_report_agencies_page = "Internal Sales Report Agencies Page",
  internal_sales_report_agencies_record_page = "Internal Sales Report Agencies Record Page",
  internal_sales_report_agents_page = "Internal Sales Report Agents Page",
  internal_sales_report_agents_record_page = "Internal Sales Report Agents Record Page",
  internal_sales_report_listing_searches_page = "Internal Sales Report Listing Searches Page",
  internal_sales_report_business_centers_page = "Internal Sales Report Business Centers Page",
  internal_sales_report_coliving_spaces_page = "Internal Sales Report Coliving Spaces Page",
  internal_sales_report_featured_agency_banners_page = "Internal Sales Report Featued Agency Banners Page",
  internal_report_card_agencies_page = "Internal Report Card Agencies Page",
  internal_report_card_agencies_record_page = "Internal Report Card Agencies Record Page",
  internal_users_user_agency_relationship_management_request_one_user_belonging_agency_update_page = "Internal Users User Agency Relationship Management Request One User Belonging Agency Update Page",
  internal_users_user_agency_relationship_management_request_one_user_managing_agencies_update_page = "Internal Users User Agency Relationship Management Request One User Managing Agencies Update Page",

  internal_building_manager_new_page = "Internal Building Manager Create Page",
  internal_building_manager_edit_page = "Internal Building Manager Edit Page",
  internal_building_manager_price_list_index_page = "Internal Building Manager Price List Page",

  internal_resources_spacious_economic_indicator_records_index_page = "Internal Resources Spacious Economic indicator records Page",

  internal_crm_index_page = "Internal CRM Page",
  internal_crm_dashboard_page = "Internal CRM Dashboard Page",
  internal_crm_leads_index_page = "Internal CRM Leads Page",
  internal_crm_leads_record_page = "Internal CRM Leads Record Page",
  internal_crm_prospects_index_page = "Internal CRM Prospects Page",
  internal_crm_single_prospect_record_page = "Internal CRM Single Prospect Record Page",
  internal_crm_closed_deals_index_page = "Internal CRM Closed Deals Page",
  internal_crm_featured_listing_quotas_index_page = "internal_crm_featured_listing_quotas_index_page",
  internal_crm_client_services_index_page = "internal_crm_client_services_index_page",
  internal_crm_client_services_record_page = "internal_crm_client_services_record_page",
  internal_crm_analytics_sales_performance_page = "Internal CRM Analytics Sales Performance Page",
  internal_crm_analytics_lead_created_page = "Internal CRM Analytics Lead Created Page",
  internal_crm_analytics_lead_assigned_page = "Internal CRM Analytics Lead Assigned Page",
  internal_crm_analytics_lead_internal_source_page = "Internal CRM Analytics Lead Internal Source Page",
  internal_crm_analytics_lead_quality = "Internal CRM Analytics Lead Quality",
  internal_crm_analytics_lead_rejection_page = "Internal CRM Analytics Lead Rejection Page",
  internal_crm_analytics_calls_logged_page = "Internal CRM Analytics Calls Logged Page",
  internal_crm_analytics_prospecting_page = "Internal CRM Analytics Prospecting Page",
  internal_crm_analytics_renewal_prospects_page = "Internal CRM Analytics Renewal Prospects Page",

  // region prospect_invoices

  internal__crm__prospect_invoices__edit_one_prospect_invoice_page =
    "internal__crm__prospect_invoices__edit_one_prospect_invoice_page",

  // endregion prospect_invoices


  // region internal real estate transaction records processing page

  page__internal_real_estate_transaction__gov_transaction_records_audit_page =
    "page--internal-real-estate-transaction--gov-transaction-records-audit-page",

  page__internal_real_estate_transaction__import_new_transaction_records_page =
    "page--internal-real-estate-transaction--import-new-transaction-records-page",

  // endregion internal real estate transaction records processing page


  // region internal forms

  page__internal_forms_neighbourhood_summary_content_update_page =
    "page--internal-forms-neighbourhood-summary-content-update-page",

  // endregion internal forms


  internal_buildings_resource_list_page_desktop_ver =
    "internal_buildings_resource_list_page_desktop_ver",


  single_school_summary_page = "single_school_summary_page",
  school_for_rent_page =       "School For Rent Page",
  school_for_sale_page =       "School For Sale Page",

  single_school_expired_for_rent_listing_list_page =
    "single_school_expired_for_rent_listing_list_page",
  single_school_expired_for_sale_listing_list_page =
    "single_school_expired_for_sale_listing_list_page",


  city_level_public_transport_stop_list_page = "Public Transport Index Page",
  single_public_transport_stop_summary_page =  "single_public_transport_stop_summary_page",
  public_transport_for_rent_page = "Public Transport For Rent Page",
  public_transport_for_sale_page = "Public Transport For Sale Page",

  single_public_transport_stop_expired_for_rent_listing_list_page =
    "single_public_transport_stop_expired_for_rent_listing_list_page",
  single_public_transport_stop_expired_for_sale_listing_list_page =
    "single_public_transport_stop_expired_for_sale_listing_list_page",


  single_street_summary_page =               "single_street_summary_page",
  single_street_sale_listing_search_page =   "single_street_sale_listing_search_page",
  single_street_rental_listing_search_page = "single_street_rental_listing_search_page",

  single_street_expired_for_rent_listing_list_page =
    "single_street_expired_for_rent_listing_list_page",
  single_street_expired_for_sale_listing_list_page =
    "single_street_expired_for_sale_listing_list_page",


  single_landmark_summary_page =               "single_landmark_summary_page",
  single_landmark_sale_listing_search_page =   "single_landmark_sale_listing_search_page",
  single_landmark_rental_listing_search_page = "single_landmark_rental_listing_search_page",

  single_landmark_expired_for_rent_listing_list_page =
    "single_landmark_expired_for_rent_listing_list_page",
  single_landmark_expired_for_sale_listing_list_page =
    "single_landmark_expired_for_sale_listing_list_page",


  city_level_overseas_properties_landing_page = "city_level_overseas_properties_landing_page",
  country_level_overseas_marketing_projects_page = "Overseas Country Page",
  city_level_overseas_marketing_projects_page = "Overseas City Page",

  city_level_serviced_apartments_landing_page =
    "city_level_serviced_apartments_landing_page",
  neighbourhood_level_serviced_apartment_list_page =
    "neighbourhood_level_serviced_apartment_list_page",

  city_level_coliving_spaces_landing_page =
    "city_level_coliving_spaces_landing_page",
  neighbourhood_level_coliving_space_list_page =
    "neighbourhood_level_coliving_space_list_page",
  single_coliving_space_summary_page =
    "single_coliving_space_summary_page",


  create_one_residential_listing_page = "create_one_residential_listing_page",
  create_one_commercial_listing_page = "create_one_commercial_listing_page",

  edit_summary_of_one_residential_listing_page = "edit_summary_of_one_residential_listing_page",
  edit_summary_of_one_commercial_listing_page = "edit_summary_of_one_commercial_listing_page",

  edit_details_of_one_residential_listing_page = "edit_details_of_one_residential_listing_page",
  edit_details_of_one_commercial_listing_page = "edit_details_of_one_commercial_listing_page",

  one_residential_listing_preview_page = "one_residential_listing_preview_page",
  one_commercial_listing_preview_page = "one_commercial_listing_preview_page",

  residential_listing_processing_result_for_published_page =
    "residential_listing_processing_result_for_published_page",
  commercial_listing_processing_result_for_published_page =
    "commercial_listing_processing_result_for_published_page",

  residential_listing_processing_result_for_updated_page =
    "residential_listing_processing_result_for_updated_page",
  commercial_listing_processing_result_for_updated_page =
    "commercial_listing_processing_result_for_updated_page",

  one_residential_listing_payment_page = "one_residential_listing_payment_page",
  one_commercial_listing_payment_page = "one_commercial_listing_payment_page",

  single_listing_details_page = "single_listing_details_page",


  city_level_tragic_event_list_page = "Tragic Events Index Page",

  city_level_school_list_page = "School List Page",

  market_news_page = "Market News Page",
  house_buying_guide = "House Buying Guide",
  user_signup_page = "User Sign up Page",
  user_signin_page = "User Sign in Page",
  user_new_password_page = "User New Password Page",
  user_edit_page = "User Edit Page",

  lister_landing_page = "lister_landing_page",
  lister_business_type_page = "lister_business_type_page",
  lister_remarketing_page = "lister_remarketing_page",
  listings_submission_pricing = "List Now Pricing Page",


  spacious_business_intro_for_domestic_residential_agencies_page =
    "spacious_business_intro_for_domestic_residential_agencies_page",
  spacious_business_intro_for_domestic_commercial_agencies_page =
    "spacious_business_intro_for_domestic_commercial_agencies_page",

  spacious_business_intro_for_domestic_project_developers_page =
    "spacious_business_intro_for_domestic_project_developers_page",
  spacious_business_intro_for_serviced_apartment_providers_page =
    "spacious_business_intro_for_serviced_apartment_providers_page",

  spacious_business_intro_for_serviced_office_providers_page =
    "spacious_business_intro_for_serviced_office_providers_page",
  spacious_business_intro_for_coworking_space_providers_page =
    "spacious_business_intro_for_coworking_space_providers_page",

  spacious_business_intro_for_overseas_real_estate_properties_providers_page =
    "spacious_business_intro_for_overseas_real_estate_properties_providers_page",

  spacious_business_intro_for_advertiser_page =
    "spacious_business_intro_for_advertiser_page",

  spacious_business_intro_for_landlords_page =
    "spacious_business_intro_for_landlords_page",

  my_follow_management_page = "my_follow_management_page",

  my_news_feed_page = "my_news_feed_page",
  my_lister_landing_page = "my_lister_landing_page",
  my_listings_posted_listings_page = "My Posted Listings",
  my_searches_edit_page = "My Searches Edit Page",
  my_notification_subscriptions_page = "My Notification Subscriptions Page",
  my_agency_clients_index_page = "My Agency Clients Index Page",
  my_agency_clients_record_page = "My Agency Clients Record Page",
  my_enquiry_history_page = "My Enquiry History Page",
  my_expiring_listings_renewal_payment_page = "My Expiring Listings Renewal Payment page",
  my_active_listings_upgrade_payment_page = "My Active Listings Upgrade Payment Page",
  my_unsubscribe_one_email_confirmation_page = "My Unsubscribe One Email Confirmation Page",
  my_shortlisted_listing_list_page = "my_shortlisted_listing_list_page",
  create_one_my_building_user_data_alias_page = "create_one_my_building_user_data_alias_page",
  my_unresponded_listing_contact_request_list_page =
    "my_unresponded_listing_contact_request_list_page",

  my_listing_manager_summary_page = "My Listing Manager Summary Page",
  listings_my_listing_manager_page = "My Listing Manager Listings Page",
  report_card_my_listing_manager_page = "report_card_my_listing_manager_page",
  users_my_listing_manager_page = "My Listing Manager Users Page",
  clients_my_listing_manager_page = "My Listing Manager Clients Page",
  one_record_clients_my_listing_manager_page = "My Listing Manager Client Record Page",

  listings_landlord_lister_dashboard_page =
    "listings_landlord_lister_dashboard_page",

  new_development_project_agency_section_summary_page =
    "new_development_project_agency_section_summary_page",

  real_estate_developer_lister_dashboard__listing_management_page =
    "real_estate_developer_lister_dashboard__listing_management_page",

  single_real_estate_agency_summary_page =
    "single_real_estate_agency_summary_page",
  single_real_estate_agency_rental_listing_search_page =
    "single_real_estate_agency_rental_listing_search_page",
  single_real_estate_agency_sale_listing_search_page =
    "single_real_estate_agency_sale_listing_search_page",

  city_level_new_development_projects_landing_page =
    "city_level_new_development_projects_landing_page",
  neighbourhood_level_new_development_projects_summary_page =
    "neighbourhood_level_new_development_projects_summary_page",
  one_new_development_project_summary_page = "one_new_development_project_summary_page",
  new_development_project_level_residential_for_rent_listing_search_page =
    "new_development_project_level_residential_for_rent_listing_search_page",
  new_development_project_level_residential_for_sale_listing_search_page =
    "new_development_project_level_residential_for_sale_listing_search_page",

  listings_contact_requests_create_several_page = "listings_contact_requests_create_several_page",

  one_overseas_project_summary_page = "one_overseas_project_summary_page",

  single_serviced_apartment_summary_page =
    "single_serviced_apartment_summary_page",

  city_level_create_one_valuation_page = "city_level_create_one_valuation_page",
  city_level_one_valuation_result_page = "city_level_one_valuation_result_page",

  city_level_real_estate_mortgages_buy_rent_summary_page =
    "city_level_real_estate_mortgages_buy_rent_summary_page",
  city_level_real_estate_mortgage_calculator_page =
    "city_level_real_estate_mortgage_calculator_page",

  city_level_coworking_space_landing_page =
    "city_level_coworking_space_landing_page",
  city_level_business_center_landing_page =
    "city_level_business_center_landing_page",
  city_level_serviced_office_landing_page =
    "city_level_serviced_office_landing_page",

  single_business_center_details_page =
    "single_business_center_details_page",
  single_serviced_office_details_page =
    "single_serviced_office_details_page",
  single_coworking_space_details_page =
    "single_coworking_space_details_page",

  city_level_commercial_landing_page = "city_level_commercial_landing_page",

  city_level_commercial_neighbourhood_list_page =
    "city_level_commercial_neighbourhood_list_page",


  single_commercial_neighbourhood_summary_page =
    "single_commercial_neighbourhood_summary_page",
  neighbourhood_level_commercial_for_sale_listing_search_page =
    "neighbourhood_level_commercial_for_sale_listing_search_page",
  neighbourhood_level_commercial_for_rent_listing_search_page =
    "neighbourhood_level_commercial_for_rent_listing_search_page",

  neighbourhood_level_expired_commercial_for_rent_listing_list_page =
    "neighbourhood_level_expired_commercial_for_rent_listing_list_page",
  neighbourhood_level_expired_commercial_for_sale_listing_list_page =
    "neighbourhood_level_expired_commercial_for_sale_listing_list_page",


  single_commercial_building_summary_page =
    "single_commercial_building_summary_page",
  building_level_commercial_for_rent_listing_search_page =
    "building_level_commercial_for_rent_listing_search_page",
  building_level_commercial_for_sale_listing_search_page =
    "building_level_commercial_for_sale_listing_search_page",

  building_level_expired_commercial_for_rent_listing_list_page =
    "building_level_expired_commercial_for_rent_listing_list_page",
  building_level_expired_commercial_for_sale_listing_list_page =
    "building_level_expired_commercial_for_sale_listing_list_page",


  lister_dashboard_2020__one_listing_data_feed_processing_job_rejected_listings_summary_page =
    "lister_dashboard_2020__one_listing_data_feed_processing_job_rejected_listings_summary_page",
  lister_dashboard_2020__create_one_real_estate_agency_custom_building_mapping_record_from_one_listing_remote_data_feed_entry_processing_record_page =
    "lister_dashboard_2020__create_one_real_estate_agency_custom_building_mapping_record_from_one_listing_remote_data_feed_entry_processing_record_page",


  internal_agency_custom_building_mappings_new_page =
    "internal_agency_custom_building_mappings_new_page",

  city_level_estate_building_transaction_ranking_page =
    "city_level_estate_building_transaction_ranking_page",

  city_level_real_estate_transaction_data_page =
    "city_level_real_estate_transaction_data_page",

  city_level_real_estate_transaction_landing_page =
    "city_level_real_estate_transaction_landing_page",

  mobile_app_redirect_page =
    "mobile_app_redirect_page",

  universal_resource_not_found_message_page =
    "universal_resource_not_found_message_page",

  unknown = "Unknown",
}
/* eslint-enable @stylistic/indent */

const getHtmlEl = _once(() => u("html"))
const getBodyEl = _once(() => u("body"))

const isCommercial = _once(() => getHtmlEl().hasClass("page-property-type-is-commercial"))

/* eslint-disable complexity */
const getCurrentPage = _once((): Enum => {
  switch (getHtmlEl().attr("id")) {
    case "page-home-index":
      return Enum.city_level_landing_page

    case "page--top_level--about_us_page":
      return Enum.about_us_page

    case "page--cities--neighbourhood-guides-page--show": {
      return Enum.city_level_residential_neighbourhood_list_page
    }

    case "page--cities--city_level_residential_rental_onboarding_page": {
      return Enum.city_level_residential_rental_onboarding_page
    }
    case "page--cities--city_level_residential_sale_onboarding_page": {
      return Enum.city_level_residential_sale_onboarding_page
    }

    case "page-cities-search-for-rent": {
      return Enum.city_level_residential_for_rent_listing_search_page
    }
    case "page-cities-search-for-sale": {
      return Enum.city_level_residential_for_sale_listing_search_page
    }

    case "page--cities--city_level_commercial_for_rent_listing_search_page": {
      return Enum.city_level_commercial_for_rent_listing_search_page
    }
    case "page--cities--city_level_commercial_for_sale_listing_search_page": {
      return Enum.city_level_commercial_for_sale_listing_search_page
    }

    case "page--real-estate-transactions--city-level-estate-building-transaction-ranking-page": {
      return Enum.city_level_estate_building_transaction_ranking_page
    }

    case "page--real-estate-transactions--city-level-real-estate-transaction-data-page": {
      return Enum.city_level_real_estate_transaction_data_page
    }

    case "page--real_estate_transactions--city_level_real_estate_transaction_landing_page": {
      return Enum.city_level_real_estate_transaction_landing_page
    }

    case "page--internal--report-card--agencies": {
      if (getBodyEl().hasClass("page--internal--report-card--agencies--index")) {
        return Enum.internal_report_card_agencies_page
      }
      if (getBodyEl().hasClass("page--internal--report-card--agencies--record")) {
        return Enum.internal_report_card_agencies_record_page
      }

      throw new Error("page--internal--report-card--agencies")
    }

    case "page--internal--users--user_agency_relationship_management--request_one_user_belonging_agency_update_page":
      return Enum.internal_users_user_agency_relationship_management_request_one_user_belonging_agency_update_page

    case "page--internal--users--user_agency_relationship_management--request_one_user_managing_agencies_update_page":
      return Enum.internal_users_user_agency_relationship_management_request_one_user_managing_agencies_update_page

    case "page--internal-building-manager--new-one-record":
      return Enum.internal_building_manager_new_page
    case "page--internal-building-manager--edit-one-record":
      return Enum.internal_building_manager_edit_page
    case "page--internal-building-manager-price-list-index":
      return Enum.internal_building_manager_price_list_index_page

    case "page--internal--resources--spacious-economic-indicator-records--index":
      return Enum.internal_resources_spacious_economic_indicator_records_index_page

    case "page--internal--crm--index":
      return Enum.internal_crm_index_page
    case "page--internal--crm--dashboard":
      return Enum.internal_crm_dashboard_page
    case "page--internal--crm--leads":
      return Enum.internal_crm_leads_index_page
    case "page--internal--crm--leads--record":
      return Enum.internal_crm_leads_record_page
    case "page--internal--crm--prospects":
      return Enum.internal_crm_prospects_index_page
    case "page--internal--crm--single_prospect_details_page":
      return Enum.internal_crm_single_prospect_record_page
    case "page--internal--crm--closed-deals":
      return Enum.internal_crm_closed_deals_index_page
    case "page--internal--crm--featured-listing-quotas":
      return Enum.internal_crm_featured_listing_quotas_index_page
    case "page--internal--crm--client-services":
      return Enum.internal_crm_client_services_index_page
    case "page--internal--crm--client-services--record":
      return Enum.internal_crm_client_services_record_page
    case "page--internal--crm--analytics--sales-performance":
      return Enum.internal_crm_analytics_sales_performance_page
    case "page--internal--crm--analytics--lead-assigned":
      return Enum.internal_crm_analytics_lead_assigned_page
    case "page--internal--crm--analytics--lead-created":
      return Enum.internal_crm_analytics_lead_created_page
    case "page--internal--crm--analytics--lead-internal-source":
      return Enum.internal_crm_analytics_lead_internal_source_page
    case "page--internal--crm--analytics--lead-quality":
      return Enum.internal_crm_analytics_lead_quality
    case "page--internal--crm--analytics--lead-rejection":
      return Enum.internal_crm_analytics_lead_rejection_page
    case "page--internal--crm--analytics--calls-logged":
      return Enum.internal_crm_analytics_calls_logged_page
    case "page--internal--crm--analytics--prospecting":
      return Enum.internal_crm_analytics_prospecting_page
    case "page--internal--crm--analytics--renewal-prospects":
      return Enum.internal_crm_analytics_renewal_prospects_page

      // region prospect_invoices

    case "page--internal--crm--prospect_invoices--edit_one_prospect_invoice_page":
      return Enum.internal__crm__prospect_invoices__edit_one_prospect_invoice_page

      // endregion prospect_invoices


      // region internal real estate transaction records processing page

    case "page--internal-real-estate-transaction--gov-transaction-records-audit-page":
      return Enum.page__internal_real_estate_transaction__gov_transaction_records_audit_page

    case "page--internal-real-estate-transaction--import-new-transaction-records-page":
      return Enum.page__internal_real_estate_transaction__import_new_transaction_records_page

      // endregion internal real estate transaction records processing page


      // region internal forms

    case "page--internal-forms-neighbourhood-summary-content-update-page":
      return Enum.page__internal_forms_neighbourhood_summary_content_update_page

      // endregion internal forms

    case "page--internal-sales-reports":
      if (getBodyEl().hasClass("page--internal-sales-reports--listings--index")){
        return Enum.internal_sales_report_listings_page
      }
      if (getBodyEl().hasClass("page--internal-sales-reports--listings--record")){
        return Enum.internal_sales_report_listings_record_page
      }
      if (getBodyEl().hasClass("page--internal-sales-reports--listings--summary")){
        return Enum.internal_sales_report_listings_summary_page
      }
      if (getBodyEl().hasClass("page--internal-sales-reports--listing-contact-requests")){
        return Enum.internal_sales_report_listing_contact_requests_page
      }
      if (getBodyEl().hasClass("page--internal-sales-reports--listing-contact-requests-nhood")){
        return Enum.internal_sales_report_neighbourhood_level_email_enquiry_report_page
      }
      if (getBodyEl().hasClass("page--internal-sales-reports--agencies--index")){
        return Enum.internal_sales_report_agencies_page
      }
      if (getBodyEl().hasClass("page--internal-sales-reports--agencies--record")){
        return Enum.internal_sales_report_agencies_record_page
      }
      if (getBodyEl().hasClass("page--internal-sales-reports--agents--index")){
        return Enum.internal_sales_report_agents_page
      }
      if (getBodyEl().hasClass("page--internal-sales-reports--agents--record")){
        return Enum.internal_sales_report_agents_record_page
      }
      if (getBodyEl().hasClass("page--internal-sales-reports--overseas-properties--index")){
        return Enum.internal_sales_report_overseas_properties_page
      }
      if (getBodyEl().hasClass("page--internal-sales-reports--serviced-apartments--index")){
        return Enum.internal_sales_report_serviced_apartment_providers_page
      }
      if (getBodyEl().hasClass("page--internal-sales-reports--listing-searches--index")){
        return Enum.internal_sales_report_listing_searches_page
      }
      if (getBodyEl().hasClass("page--internal-sales-reports--business-centers--index")){
        return Enum.internal_sales_report_business_centers_page
      }
      if (getBodyEl().hasClass("page--internal-sales-reports--coliving-spaces--index")){
        return Enum.internal_sales_report_coliving_spaces_page
      }
      if (getBodyEl().hasClass("page--internal-sales-reports--featured-agency-banners--index")){
        return Enum.internal_sales_report_featured_agency_banners_page
      }

      throw new Error("page--internal-sales-reports")

    case "page--internal--resources--buildings--resource_list_page--show--desktop_ver": {
      return Enum.internal_buildings_resource_list_page_desktop_ver
    }


    case "page--buildings--city_level_overseas_properties_landing_page":
      return Enum.city_level_overseas_properties_landing_page
    case "page--buildings--country_level_overseas_marketing_projects_page":
      return Enum.country_level_overseas_marketing_projects_page
    case "page--buildings--city_level_overseas_marketing_projects_page":
      return Enum.city_level_overseas_marketing_projects_page

    case "page--serviced_apartments--city_level_serviced_apartments_landing_page":
      return Enum.city_level_serviced_apartments_landing_page
    case "page--serviced_apartments--neighbourhood_level_serviced_apartment_list_page":
      return Enum.neighbourhood_level_serviced_apartment_list_page

    case "page--coliving_spaces--city_level_coliving_spaces_landing_page":
      return Enum.city_level_coliving_spaces_landing_page
    case "page--coliving_spaces--neighbourhood_level_coliving_space_list_page":
      return Enum.neighbourhood_level_coliving_space_list_page
    case "page--coliving_spaces--single_coliving_space_summary_page":
      return Enum.single_coliving_space_summary_page


    case "page-neighbourhoods-show":
      return Enum.single_residential_neighbourhood_summary_page
    case "page--neighbourhoods--neighbourhood_level_residential_for_rent_listing_search_page":
      return Enum.neighbourhood_level_residential_for_rent_listing_search_page
    case "page--neighbourhoods--neighbourhood_level_residential_for_sale_listing_search_page":
      return Enum.neighbourhood_level_residential_for_sale_listing_search_page
    case "page-neighbourhoods-transactions": {
      return Enum.neighbourhood_level_residential_transaction_list_page
    }

    case "page--neighbourhoods--neighbourhood_level_expired_residential_for_rent_listing_list_page": {
      return Enum.neighbourhood_level_expired_residential_for_rent_listing_list_page
    }
    case "page--neighbourhoods--neighbourhood_level_expired_residential_for_sale_listing_list_page": {
      return Enum.neighbourhood_level_expired_residential_for_sale_listing_list_page
    }


    case "page-buildings-show":
      return Enum.single_residential_building_summary_page
    case "page--buildings--building_level_residential_for_rent_listing_search_page":
      return Enum.building_level_residential_for_rent_listing_search_page
    case "page--buildings--building_level_residential_for_sale_listing_search_page":
      return Enum.building_level_residential_for_sale_listing_search_page
    case "page--real_estate_transactions--building_level_real_estate_transaction_list_page": {
      return Enum.building_level_residential_transaction_list_page
    }

    case "page--buildings--building_level_expired_residential_for_rent_listing_list_page": {
      return Enum.building_level_expired_residential_for_rent_listing_list_page
    }
    case "page--buildings--building_level_expired_residential_for_sale_listing_list_page": {
      return Enum.building_level_expired_residential_for_sale_listing_list_page
    }

    // region special_categories

    case "page--special_categories--city_level_special_categories_landing_page": {
      return Enum.city_level_special_categories_landing_page
    }
    case "page--special_categories--city_level_special_categories_for_sale_listing_search_page": {
      return Enum.city_level_special_categories_for_sale_listing_search_page
    }
    case "page--special_categories--city_level_special_categories_for_rent_listing_search_page": {
      return Enum.city_level_special_categories_for_rent_listing_search_page
    }

    // endregion special_categories

    // region village_houses

    case "page--special_categories--city_level_village_houses_for_rent_listing_search_page": {
      return Enum.city_level_village_houses_for_rent_listing_search_page
    }
    case "page--special_categories--city_level_village_houses_for_sale_listing_search_page": {
      return Enum.city_level_village_houses_for_sale_listing_search_page
    }

    // endregion village_houses

    // region home_ownership_scheme

    case "page--special_categories--city_level_home_ownership_scheme_landing_page": {
      return Enum.city_level_home_ownership_scheme_landing_page
    }

    case "page--special_categories--neighbourhood_level_home_ownership_scheme_summary_page": {
      return Enum.neighbourhood_level_home_ownership_scheme_summary_page
    }

    case "page--special_categories--neighbourhood_level_home_ownership_scheme_for_sale_listing_search_page": {
      return Enum.neighbourhood_level_home_ownership_scheme_for_sale_listing_search_page
    }

    case "page--special_categories--neighbourhood_level_home_ownership_scheme_for_rent_listing_search_page": {
      return Enum.neighbourhood_level_home_ownership_scheme_for_rent_listing_search_page
    }

    // endregion home_ownership_scheme


    case "page-listings-new": {
      return Enum.create_one_residential_listing_page
    }
    case "page--commercial--listings--new": {
      return Enum.create_one_commercial_listing_page
    }

    case "page-listings-edit": {
      return Enum.edit_summary_of_one_residential_listing_page
    }
    case "page--commercial--listings--edit": {
      return Enum.edit_summary_of_one_commercial_listing_page
    }

    case "page--listings--edit-details": {
      return Enum.edit_details_of_one_residential_listing_page
    }
    case "page--commercial--listings--details": {
      return Enum.edit_details_of_one_commercial_listing_page
    }


    case "page-listings-preview": {
      return Enum.one_residential_listing_preview_page
    }
    case "page--commercial--listings--preview": {
      return Enum.one_commercial_listing_preview_page
    }

    case "page--listings--residential-listing-processing-result-for-published-page": {
      return Enum.residential_listing_processing_result_for_published_page
    }
    case "page--listings--commercial-listing-processing-result-for-published-page": {
      return Enum.commercial_listing_processing_result_for_published_page
    }

    case "page--listings--residential-listing-processing-result-for-updated-page": {
      return Enum.residential_listing_processing_result_for_updated_page
    }
    case "page--listings--commercial-listing-processing-result-for-updated-page": {
      return Enum.commercial_listing_processing_result_for_updated_page
    }

    case "page-listings-pay": {
      return Enum.one_residential_listing_payment_page
    }
    case "page--commercial--listings--pay": {
      return Enum.one_commercial_listing_payment_page
    }

    case "page--listings--single_listing_details_page": {
      return Enum.single_listing_details_page
    }


    case "page--market-news--index":

      return Enum.market_news_page
    case "page-users-registrations-new":

      return Enum.user_signup_page
    case "page-users-sessions-new":
      return Enum.user_signin_page
    case "page-users-registrations-edit":
      return Enum.user_edit_page
    case "page-users-passwords-new":
      return Enum.user_new_password_page

    case "page--listers--lister_landing_page":
      return Enum.lister_landing_page
    case "page--listers--business-type-page":
      return Enum.lister_business_type_page
    case "page--listers--remarketing-page":
      return Enum.lister_remarketing_page
    case "page-listings-submission-pricing":
      return Enum.listings_submission_pricing


    case "page--schools--single_school_summary_page": {
      return Enum.single_school_summary_page
    }
    case "page--cities-schools--listings--for-sale": {
      return Enum.school_for_sale_page
    }
    case "page--cities-schools--listings--for-rent": {
      return Enum.school_for_rent_page
    }

    case "page--schools--single_school_expired_for_rent_listing_list_page": {
      return Enum.single_school_expired_for_rent_listing_list_page
    }
    case "page--schools--single_school_expired_for_sale_listing_list_page": {
      return Enum.single_school_expired_for_sale_listing_list_page
    }


    case "page--public_transport_stops--city_level_public_transport_stop_list_page": {
      return Enum.city_level_public_transport_stop_list_page
    }
    case "page--public_transport_stops--single_public_transport_stop_summary_page": {
      return Enum.single_public_transport_stop_summary_page
    }
    case "page--public_transport_stops--single_public_transport_stop_rental_listing_search_page": {
      return Enum.public_transport_for_rent_page
    }
    case "page--public_transport_stops--single_public_transport_stop_sale_listing_search_page": {
      return Enum.public_transport_for_sale_page
    }

    case "page--public_transport_stops--single_public_transport_stop_expired_for_rent_listing_list_page": {
      return Enum.single_public_transport_stop_expired_for_rent_listing_list_page
    }
    case "page--public_transport_stops--single_public_transport_stop_expired_for_sale_listing_list_page": {
      return Enum.single_public_transport_stop_expired_for_sale_listing_list_page
    }


    case "page--tragic_events--city_level_tragic_event_list_page":
      return Enum.city_level_tragic_event_list_page
    case "page--cities-resources--house_buying_guide":
      return Enum.house_buying_guide
    case "page--schools--city_level_school_list_page":
      return Enum.city_level_school_list_page


    case "page--streets--single_street_summary_page": {
      return Enum.single_street_summary_page
    }
    case "page--streets--single_street_sale_listing_search_page": {
      return Enum.single_street_sale_listing_search_page
    }
    case "page--streets--single_street_rental_listing_search_page": {
      return Enum.single_street_rental_listing_search_page
    }

    case "page--streets--single_street_expired_for_rent_listing_list_page": {
      return Enum.single_street_expired_for_rent_listing_list_page
    }
    case "page--streets--single_street_expired_for_sale_listing_list_page": {
      return Enum.single_street_expired_for_sale_listing_list_page
    }


    case "page--landmarks--single_landmark_summary_page": {
      return Enum.single_landmark_summary_page
    }
    case "page--landmarks--single_landmark_sale_listing_search_page": {
      return Enum.single_landmark_sale_listing_search_page
    }
    case "page--landmarks--single_landmark_rental_listing_search_page": {
      return Enum.single_landmark_rental_listing_search_page
    }

    case "page--landmarks--single_landmark_expired_for_rent_listing_list_page": {
      return Enum.single_landmark_expired_for_rent_listing_list_page
    }
    case "page--landmarks--single_landmark_expired_for_sale_listing_list_page": {
      return Enum.single_landmark_expired_for_sale_listing_list_page
    }


    case "page--real_estate_agencies--single_real_estate_agency_summary_page": {
      return Enum.single_real_estate_agency_summary_page
    }
    case "page--real_estate_agencies--single_real_estate_agency_rental_listing_search_page": {
      return Enum.single_real_estate_agency_rental_listing_search_page
    }
    case "page--real_estate_agencies--single_real_estate_agency_sale_listing_search_page": {
      return Enum.single_real_estate_agency_sale_listing_search_page
    }

    case "page--new_property_developments--city_level_new_development_projects_landing_page":
      return Enum.city_level_new_development_projects_landing_page
    case "page--new_property_developments--neighbourhood_level_new_development_projects_summary_page":
      return Enum.neighbourhood_level_new_development_projects_summary_page
    case "page--single-building-page--new-dev-style":
      return Enum.one_new_development_project_summary_page
    case "page--new_property_developments--new_development_project_level_residential_for_rent_listing_search_page":
      return Enum.new_development_project_level_residential_for_rent_listing_search_page
    case "page--new_property_developments--new_development_project_level_residential_for_sale_listing_search_page":
      return Enum.new_development_project_level_residential_for_sale_listing_search_page

    case "page--listings--contact--requests--create-several":
      return Enum.listings_contact_requests_create_several_page
    case "page--listing_contact_requests--create_for_many_listings--enquiries_sent":
      return Enum.listings_contact_requests_create_several_page

    case "page--buildings--single_overseas_residential_project_summary_page":
      return Enum.one_overseas_project_summary_page

    case "page--serviced_apartments--single_serviced_apartment_summary_page":
      return Enum.single_serviced_apartment_summary_page

    case "page-my-news-feeds-show": {
      return Enum.my_news_feed_page
    }
    case "page--my-follow-management--index": {
      return Enum.my_follow_management_page
    }
    case "page--my-listings-submission--index": {
      return Enum.my_lister_landing_page
    }
    case "page--my-listings-posted-listings--index": {
      return Enum.my_listings_posted_listings_page
    }

    case "page--my-notification-subscriptions--index": {
      return Enum.my_notification_subscriptions_page
    }

    case "page--my-searches--edit": {
      return Enum.my_searches_edit_page
    }

    case "page--my-agency-clients--index": {
      return Enum.my_agency_clients_index_page
    }

    case "page--my-agency-clients--record": {
      return Enum.my_agency_clients_record_page
    }

    case "page--my_enquiry_history_page": {
      return Enum.my_enquiry_history_page
    }

    case "page--my_expiring_listings_renewal_payment_page": {
      return Enum.my_expiring_listings_renewal_payment_page
    }

    case "page--my_active_listings_upgrade_payment_page": {
      return Enum.my_active_listings_upgrade_payment_page
    }

    case "page--my-unsubscribe-one-email-confirmation": {
      return Enum.my_unsubscribe_one_email_confirmation_page
    }

    case "page-my-shortlisted-listings-index": {
      return Enum.my_shortlisted_listing_list_page
    }
    case "page--my--buildings--user-data-aliases--new": {
      return Enum.create_one_my_building_user_data_alias_page
    }
    case "page-my-listing-contact-unresponded-requests": {
      return Enum.my_unresponded_listing_contact_request_list_page
    }

    case "page--my-listing-manager--summary": {
      return Enum.my_listing_manager_summary_page
    }

    case "page--my-listing-manager--listings": {
      return Enum.listings_my_listing_manager_page
    }

    case "page--my-listing-manager--users": {
      return Enum.users_my_listing_manager_page
    }

    case "page--my-listing-manager--clients": {
      return Enum.clients_my_listing_manager_page
    }

    case "page--my-listing-manager--report-card": {
      return Enum.report_card_my_listing_manager_page
    }

    case "page--my-listing-manager--clients--record": {
      return Enum.one_record_clients_my_listing_manager_page
    }

    case "page--landlord-lister-dashboard--listings": {
      return Enum.listings_landlord_lister_dashboard_page
    }

    case "page--new-development-project-agency-section-summary": {
      return Enum.new_development_project_agency_section_summary_page
    }

    case "page--real-estate-developer-lister-dashboard--listings": {
      return Enum.real_estate_developer_lister_dashboard__listing_management_page
    }

    case "page-valuations-new": {
      return Enum.city_level_create_one_valuation_page
    }
    case "page--real_estate_property_valuations--city_level_one_valuation_result_page": {
      return Enum.city_level_one_valuation_result_page
    }

    case "page--cities-real-estate-mortgages-buy-rent-summary": {
      return Enum.city_level_real_estate_mortgages_buy_rent_summary_page
    }
    case "page-real-estate-mortgages-calculator-listing": {
      return Enum.city_level_real_estate_mortgage_calculator_page
    }


    case "page--cities--city_level_commercial_rental_onboarding_page": {
      return Enum.city_level_commercial_rental_onboarding_page
    }
    case "page--cities--city_level_commercial_sale_onboarding_page": {
      return Enum.city_level_commercial_sale_onboarding_page
    }

    case "page--business_centers--city_level_coworking_space_landing_page": {
      return Enum.city_level_coworking_space_landing_page
    }
    case "page--business_centers--city_level_serviced_office_landing_page": {
      return Enum.city_level_serviced_office_landing_page
    }
    case "page--business_centers--city_level_business_center_landing_page": {
      return Enum.city_level_business_center_landing_page
    }

    case "page--business_centers--single_business_center_details_page": {
      return Enum.single_business_center_details_page
    }
    case "page--business_centers--single_serviced_office_details_page": {
      return Enum.single_serviced_office_details_page
    }
    case "page--business_centers--single_coworking_space_details_page": {
      return Enum.single_coworking_space_details_page
    }

    case "page--top_level--city_level_commercial_landing_page":
      return Enum.city_level_commercial_landing_page

    case "page--cities--city_level_commercial_neighbourhood_list_page":
      return Enum.city_level_commercial_neighbourhood_list_page


    case "page--neighbourhoods--single_commercial_neighbourhood_summary_page":
      return Enum.single_commercial_neighbourhood_summary_page
    case "page--neighbourhoods--neighbourhood_level_commercial_for_sale_listing_search_page":
      return Enum.neighbourhood_level_commercial_for_sale_listing_search_page
    case "page--neighbourhoods--neighbourhood_level_commercial_for_rent_listing_search_page":
      return Enum.neighbourhood_level_commercial_for_rent_listing_search_page

    case "page--neighbourhoods--neighbourhood_level_expired_commercial_for_rent_listing_list_page": {
      return Enum.neighbourhood_level_expired_commercial_for_rent_listing_list_page
    }
    case "page--neighbourhoods--neighbourhood_level_expired_commercial_for_sale_listing_list_page": {
      return Enum.neighbourhood_level_expired_commercial_for_sale_listing_list_page
    }


    case "page--buildings--single_commercial_building_summary_page":
      return Enum.single_commercial_building_summary_page

    case "page--buildings--building_level_commercial_for_rent_listing_search_page":
      return Enum.building_level_commercial_for_rent_listing_search_page

    case "page--buildings--building_level_commercial_for_sale_listing_search_page":
      return Enum.building_level_commercial_for_sale_listing_search_page

    case "page--buildings--building_level_expired_commercial_for_rent_listing_list_page": {
      return Enum.building_level_expired_commercial_for_rent_listing_list_page
    }
    case "page--buildings--building_level_expired_commercial_for_sale_listing_list_page": {
      return Enum.building_level_expired_commercial_for_sale_listing_list_page
    }


    case "page--lister_dashboard_2020--one_listing_data_feed_processing_job_rejected_listings_summary_page": {
      return Enum.lister_dashboard_2020__one_listing_data_feed_processing_job_rejected_listings_summary_page
    }
    case "page--lister_dashboard_2020--create_one_real_estate_agency_custom_building_mapping_record_from_one_listing_remote_data_feed_entry_processing_record_page": {
      return Enum.lister_dashboard_2020__create_one_real_estate_agency_custom_building_mapping_record_from_one_listing_remote_data_feed_entry_processing_record_page
    }


    case "pages--internal--resources--real_estate_agencies--custom_building_mappings--new":
      return Enum.internal_agency_custom_building_mappings_new_page

    case "page--redirects--mobile_app_redirect_page":
      return Enum.mobile_app_redirect_page

    case "page-errors-error404":
      return Enum.universal_resource_not_found_message_page

    default:
      return Enum.unknown
  }
})
/* eslint-enable complexity */


const isRentalPage = _once(() =>
  [
    Enum.city_level_residential_rental_onboarding_page,
    Enum.city_level_residential_for_rent_listing_search_page,
    Enum.school_for_rent_page,
    Enum.public_transport_for_rent_page,
  ].includes(getCurrentPage())
)

const isSalePage = _once(() =>
  [
    Enum.city_level_residential_sale_onboarding_page,
    Enum.city_level_residential_for_sale_listing_search_page,
    Enum.school_for_sale_page,
    Enum.public_transport_for_sale_page,
  ].includes(getCurrentPage())
)

// TODO: move this as separate file?
const enum_track_name_map: {[index: string]: string} = {
  [Enum.city_level_landing_page]: "Homepage",

  [Enum.city_level_residential_rental_onboarding_page]: "Rental Question Page",
  [Enum.city_level_residential_sale_onboarding_page]:   "Sale Question Page",

  [Enum.city_level_residential_for_rent_listing_search_page]: "For Rent Page",
  [Enum.city_level_residential_for_sale_listing_search_page]: "For Sale Page",

  [Enum.city_level_special_categories_for_rent_listing_search_page]:
    "Special Categories For Rent page",
  [Enum.city_level_special_categories_for_sale_listing_search_page]:
    "Special Categories For Sale page",

  [Enum.single_residential_building_summary_page]:
    "Building Page",
  [Enum.building_level_residential_for_rent_listing_search_page]:
    "Building For Rent Page",
  [Enum.building_level_residential_for_sale_listing_search_page]:
    "Building For Sale Page",

  [Enum.single_residential_neighbourhood_summary_page]:
    "Neighbourhood Page",
  [Enum.neighbourhood_level_residential_for_rent_listing_search_page]:
    "Neighbourhood For Rent Page",
  [Enum.neighbourhood_level_residential_for_sale_listing_search_page]:
    "Neighbourhood For Sale Page",

  [Enum.school_for_rent_page]:
    "School For Rent Page",
  [Enum.school_for_sale_page]:
    "School For Sale Page",
  [Enum.public_transport_for_rent_page]: "Public Transport For Rent Page",
  [Enum.public_transport_for_sale_page]: "Public Transport For Sale Page",

  [Enum.single_listing_details_page]: "Full Listing Page",

  [Enum.single_street_sale_listing_search_page]:   "Single Street Sale Listing Search Page",
  [Enum.single_street_rental_listing_search_page]: "Single Street Rental Listing Search Page",

  [Enum.one_overseas_project_summary_page]: "One Overseas Project Summary Page",

  [Enum.single_serviced_apartment_summary_page]:
    "One Serviced Apartment Summary Page",
  [Enum.city_level_new_development_projects_landing_page]:
    "New Development Page",
  [Enum.neighbourhood_level_new_development_projects_summary_page]:
    "Neighbourhood New Development Page",

  [Enum.city_level_serviced_apartments_landing_page]:
    "City Serviced Apartments Page",
  [Enum.neighbourhood_level_serviced_apartment_list_page]:
    "Neighbourhood Serviced Apartments Page",

  [Enum.city_level_real_estate_mortgage_calculator_page]:
    "Real Estate Mortgages Calculator Page",

  [Enum.unknown]: "Unknown",
}

const PageInstance = {
  currentPage(): Enum {
    return getCurrentPage()
  },
  currentPageNameForTracking(): string {
    const page_type_id_for_tracking_from_page = DataRetriever.get("page-type-id-for-tracking")
    if (typeof page_type_id_for_tracking_from_page === "string") {
      const app_data_container_el = document.getElementById("app-data-container")
      let current_listing_search_page_map_or_list_mode = null
      if (app_data_container_el != null) {
        current_listing_search_page_map_or_list_mode =
          app_data_container_el.getAttribute("current-listing-search-page-map-or-list-mode")

        switch (current_listing_search_page_map_or_list_mode) {
          case "hybrid":
            return `${page_type_id_for_tracking_from_page} / Hybrid View`
          case "map":
            return `${page_type_id_for_tracking_from_page} / Map View`
          case "list":
            return `${page_type_id_for_tracking_from_page} / List View`
          default:
            // Nope nothing to be done
        }
      }

      return page_type_id_for_tracking_from_page
    }

    const current_page_name = getCurrentPage()

    if (current_page_name in enum_track_name_map) {
      return enum_track_name_map[current_page_name]
    }

    // Pointless to keep updating display name for each page type
    // Just fallback to page "id"
    // Whatever value it is, still better than `unknown`
    if (typeof current_page_name === "string" && current_page_name !== Enum.unknown) {
      return current_page_name
    }

    return enum_track_name_map[Enum.unknown]
  },
  Enum,
  isCommercial,
  isRentalPage,
  isSalePage,
}

export default PageInstance
export {
  PageInstance,
}
